import { render, staticRenderFns } from "./UsersForm.vue?vue&type=template&id=5cb0c52e&scoped=true&"
import script from "./UsersForm.vue?vue&type=script&lang=js&"
export * from "./UsersForm.vue?vue&type=script&lang=js&"
import style0 from "./UsersForm.vue?vue&type=style&index=0&id=5cb0c52e&prod&lang=css&"
import style1 from "./UsersForm.vue?vue&type=style&index=1&id=5cb0c52e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0c52e",
  null
  
)

export default component.exports